import { SemanticModel } from "@pufflig/prompt-studio-types";
import { getConnectorSchema } from "../../../PromptbookEditor/hooks/useConnectorSchema";
import { useSemanticModelStore } from "../SemanticModelProvider";
import { reconcileSemanticModel } from "./reconcileSemanticModel";

export const loadConnectorSchema = async (connectorId: string): Promise<SemanticModel | null> => {
  const data = await getConnectorSchema(connectorId);
  useSemanticModelStore.setState(
    (state) => {
      state.dbSchema = data || null;
    },
    false,
    "schema/db_schema",
  );
  reconcileSemanticModel();
  return data || null;
};
